import { useState, useEffect } from "react";
import axios from "axios";
import { useMatch } from "react-router-dom";
import { CONTENT_ROUTES } from "../routes/content-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";

export default function Page() {
  const slug = useMatch("/:slug/*");
  const pageSlugs = slug.pathname?.split("/")?.filter((str) => str !== "");
  const pageSlug = pageSlugs[pageSlugs.length - 1];
  const [page, setPage] = useState({});
  let { getMetaSnippet } = useUtilities();

  useEffect(() => {
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", pageSlug + `&_embed`))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};
        setPage(pageResponse);
      })
      .catch((err) => {})
      .finally(() => {});
  }, [pageSlug]);

  return (
    <>
      <Helmet>
        <title>{page?.title?.rendered + ` - Nant Power`}</title>
        <meta
          name="description"
          content={getMetaSnippet(page?.content?.rendered)}
        />
      </Helmet>
      <Header />
      <main>
        <section>
          <div className="container mx-auto md:pt-16 md:px-16 px-8 pt-8">
            <div className="text-base">
              <div className="md:w-full flex content-center text-white mb-8">
                <div className="flex">
                  <img
                    className="mr-5 h-12 -mt-2"
                    src="/images/electric-bolt-solid.svg"
                    alt="Nant Power Project Icon"
                  />
                  <div className="text-xl font-semibold text-gray-500">
                    {slug?.params?.slug
                      ?.replace("-", " ")
                      .split(" ")
                      .map(
                        (word) =>
                          word.charAt(0).toUpperCase() +
                          word.slice(1).toLowerCase()
                      )
                      .join(" ")}
                  </div>
                </div>
              </div>

              <h1 className="text-4xl font-semibold text-[#0070b9]">
                {page?.title?.rendered}
              </h1>
            </div>
          </div>
        </section>
        <section className="md:pb-20">
          <div className="container mx-auto py-10 md:p-16 md:px-16 px-8 bg-white ">
            <div className="text-base leading-7">
              <div className="max-w-4xl">
                <div
                  dangerouslySetInnerHTML={{
                    __html: page?.content?.rendered?.replace(
                      /<p.*?>/g,
                      "<p class='mb-5'>"
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
